import { render, staticRenderFns } from "./MyQuizzesLegend.vue?vue&type=template&id=cb927d82&scoped=true&"
import script from "./MyQuizzesLegend.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb927d82",
  null
  
)

export default component.exports